import { ModalLayoutProps } from 'components/Modals';
import ModalLayout from 'components/Modals/ModalLayout';

interface Props extends ModalLayoutProps {
    Component: React.ComponentType<{ isEditMode?: boolean }>;
}
export default function EditInformation({ onClose, visible, Component }: Props) {
    return (
        <ModalLayout visible={visible} onClose={onClose}>
            <div className="w-full max-w-full default-lg:max-w-[700px] default-md:max-w-[550px] block  bg-white pt-20">
                <div className="absolute top-0 left-0">
                    <h1 className=" font-medium text-xl font-poppins p-4">Edit Information</h1>
                </div>
                <div className="border border-gray-200 w-full absolute top-16 left-0 " />

                <div className="flex gap-4 flex-col px-4">
                    <Component isEditMode />
                </div>
                <div className="px-4">
                    <button className="py-3 w-full bg-my-green text-white text-lg  rounded-lg mb-5 mt-8" onClick={onClose}>
                        Save
                    </button>
                </div>
            </div>
        </ModalLayout>
    );
}
